import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=fe06425e&scoped=true"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"
import style0 from "./changelog.vue?vue&type=style&index=0&id=fe06425e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe06425e",
  null
  
)

export default component.exports